const pug = require("!../../node_modules/pug-runtime/index.js");

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;pug_html = pug_html + "\u003Cdiv class=\"eps-help\" ng-show=\"$ctrl.showEPSHelp()\"\u003E\u003Cimg ng-src=\"resources\u002Fchat-button.svg\" alt=\"\" ng-click=\"$ctrl.showHelp()\"\u003E\u003C\u002Fdiv\u003E";;return pug_html;};
module.exports = template;